import { Action, AppDispatch, AppThunk } from '../../definitions/types';
import * as Actions from './actions-consts';

export function preselectTemplate(subtype: string): AppThunk {
  return (dispatch: AppDispatch) => {
    dispatch(setSubtype(subtype));
    dispatch(skipTemplateView());
  };
}

export function setSubtype(subtype: string): Action<string> {
  return {
    type: Actions.SET_SUBTYPE,
    payload: subtype,
    meta: {
      tracked: { action: 'subtype', label: 'set' },
    },
  };
}

export function increaseAmount(maxAmount: number): Action<number> {
  return {
    type: Actions.INCREASE_AMOUNT_TEMPLATES,
    payload: maxAmount,
    meta: {
      tracked: { action: 'amount-templates', label: 'increase' },
    },
  };
}

export function resetAmount(): Action<void> {
  return {
    type: Actions.RESET_AMOUNT_TEMPLATES,
  };
}

export function skipTemplateView(): Action<void> {
  return {
    type: Actions.SKIP_TEMPLATE_VIEW,
    meta: {
      tracked: { action: 'template-view', label: 'skip' },
    },
  };
}
